export default "__VITE_PUBLIC_ASSET__13c2d1ee__"